<ng-container>
  @if (wellIsSelected) {
    <app-owner-well-info [application]="application" [form]="form?.get('ownerWellInfo')" [organization]="organization" (notesRequested)="handleNotesRequested($event)"></app-owner-well-info>
    <app-well-information [form]="form?.get('wellInfo')" [organization]="organization" [application]="application" (notesRequested)="handleNotesRequested($event)"></app-well-information>
    <app-casing-and-tubing [form]="form?.get('casingTubing')" [application]="application" [dataTypes]="dataTypes" (notesRequested)="handleNotesRequested($event)"></app-casing-and-tubing>
    <app-completion-information [form]="form?.get('completionInfo')" [application]="application" (notesRequested)="handleNotesRequested($event)" [formations]="formations"></app-completion-information>
    <app-initial-production [form]="form?.get('initialProd')" [application]="application" (notesRequested)="handleNotesRequested($event)"></app-initial-production>
    <app-formations [form]="form?.get('formations')" [countedItems]="itemList" [methodTypes]="methods" [application]="application" (notesRequested)="handleNotesRequested($event)"></app-formations>
    <app-received-dates [application]="application" [reportType]="reportType" [form]="form?.get('receivedDates')" (notesRequested)="handleNotesRequested($event)"></app-received-dates>
    <app-user-updates [application]="application" [form]="form?.get('userUpdates')" [well]="well"></app-user-updates>
    <app-documentation [form]="form?.get('documentation')" [application]="application" [onBaseDocumentTypes]="onBaseDocumentTypes" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-documentation>
    <app-certification [form]="form?.get('certifications')" [application]="application" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-certification>
    <div class="grid-x grid-margin-x">
      <div class="large-12 medium-12 small-12 text-align-center">
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onReturn()">Return For Corrections</button>
          </span>
        }
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onAccept()">Accept</button>
          </span>
        }
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onSave()">Save for Later</button>
          </span>
        }
        <span>
          <button class="button" (click)="cancel()">Cancel</button>
        </span>
      </div>
    </div>
  }
</ng-container>
